import limitImgPath from "@/assets/images/article-limit-image.png";

export function formatData(contentJson, entryDataBind, entryMap, loginUser) {
  // console.log(contentJson, entryDataBind);
  if (!contentJson) return;
  const data = JSON.parse(contentJson);
  let { baseData, styleData } = data;
  const baseTableData = baseData.flat();
  // 处理老数据
  if (!Array.isArray(data.styleData)) {
    styleData = Object.keys(data.styleData).map(name => {
      const styleData = data.styleData[name];
      const key = styleData[0][0].key;
      return {
        key,
        name,
        data: styleData
      };
    });
  }
  let styleTableData = [];
  styleData.forEach(item => {
    styleTableData = styleTableData.concat(item.data.flat());
  });
  const allTableData = [...baseTableData, ...styleTableData];
  // 深度拷贝
  let dataSource = JSON.parse(JSON.stringify(entryMap));

  // 未认证通过且不是超管
  const isLimitUser = !(loginUser.uid && loginUser.verify_level == 2 && loginUser.adulthood) && !loginUser.is_super;

  // 递归处理数据
  function deepMap(dataSource) {
    Object.keys(dataSource).forEach(key => {
      const current = dataSource[key];
      if (typeof current === "object") {
        // console.log(current);
        if (typeof current.key === "string" && typeof current.type === "string") {
          const mapKey = current.key;
          const originKey = entryDataBind[mapKey];
          // console.log(originMapData);
          if (originKey) {
            const tableData = allTableData.find(it => it.key === originKey);
            if (tableData) {
              current.hasValue = true;
              // 实名认证数据
              if (
                tableData.reallyAuth &&
                tableData.reallyAuth.isOpen &&
                ["image", "video"].includes(current.type) &&
                isLimitUser
              ) {
                current.isLimit = true;
                current.reallyAuth = tableData.reallyAuth;
                current.value = tableData.reallyAuth.backupImg || limitImgPath;
              } else {
                current.value = tableData.value;
              }
            }
          }
        } else {
          deepMap(current);
        }
      }
    });
  }
  if (entryDataBind) {
    deepMap(dataSource);
  }
  return JSON.parse(JSON.stringify(dataSource));
}
